/**
 * Input types to be rendered by PromptList widgets.
 */
export default {
    // ----- INPUT TYPES ----- //
    LIST: "LIST",
    LIST_VIEW: "LIST_VIEW", // USE WITH CAUTION; LIKELY USED ONLY IN FORMS AND PROMPT USER TASK DUE TO PLACEMENT ISSUES AND NO RETRAINING; TYPICALLY USE LIST INSTEAD
    TEXT_FIELD: "TEXT_FIELD",
    DATE_FIELD: "DATE_FIELD",
    SWITCH: "SWITCH",
    TEXT_AREA: "TEXT_AREA",
    // ----- NON-INPUT TYPES ----- //
    READ_ONLY: "READ_ONLY",
    TABLE: "TABLE",
    BUTTON: "BUTTON",
    H_LINE: "HORIZONTAL_LINE",
    V_LINE: "VERTICAL_LINE",
    IMAGE: "IMAGE",
    DYNAMIC_FIELD: "DYNAMIC_FIELD", // used by Indexing for fields that we cannot determine whether it should be a typed-input or drop down
    LINK: "LINK",
    FILE_UPLOAD: "FILE_UPLOAD",

    canHaveInput: function(type) {
        return type !== this.READ_ONLY && type !== this.TABLE && type !== this.BUTTON && type !== this.H_LINE && type !== this.V_LINE && type !== this.IMAGE && type !== this.LINK && type !== this.FILE_UPLOAD;
    }
}
